import CustomSelectOption from "@components/CustomSelectOption";
import DropDown from "@components/dropDown";
import Pagination from "@components/Pagination";
import NewCourses from "@components/ui/landing/NewCourses";
import {
  setFilterQuery,
  setPageNumber,
  setSortBy,
} from "@store/reducers/search";
import FillArrow from "assets/svg/fill-arrow.svg";
import Filter from "assets/svg/filter.svg";
import Search from "assets/svg/search.svg";
import Sort from "assets/svg/sort.svg";
import Surprise from "assets/svg/surprise.svg";
import { Button, Spinner, Title } from "components";
import DesktopTab from "components/ui/search/Tab/DesktopTab";
import Items from "components/ui/search/Tab/Items";
import gate from "gate";
import { SortCourseBy } from "interfaces";
import debounce from "lodash/debounce";
import { NextPageContext } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { generateUuidForReactList, getTitleByEnum } from "src/utils";

const sortList = [
  { title: "مرتبط ترین", value: SortCourseBy.RecentlyAdded },
  { title: "بیشترین بازدید", value: SortCourseBy.MostlyViewed },
  { title: "جدیدترین دوره", value: SortCourseBy.RecentlyUpdated },
  // { title: 'منتخب کاربران', value: SortCourseBy.SelectedByUsers },
  { title: "پرفروش ترین ها", value: SortCourseBy.MostlySelled },
];

let _timer: any | null = null;
const Index: FC = () => {
  const isFirstMounted = useRef(true);
  const [recommendedList, setRecommendedList] = useState<null | []>(null);
  const [totalCount, setTotalCount] = useState(null);
  const [searchDto, setSearchDto] = useState({
    search: "",
    pageSize: 15,
    pageNumber: 1,
    fieldSearchs: [
      {
        fieldName: "",
        text: "",
      },
    ],
  });
  const { query: pageQuery } = useRouter();
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.search);
  const {
    mutate,
    data: items,
    isLoading,
  }: any = useMutation(gate.searchAdvanceWithPagination);
  const { data, isSuccess } = useQuery(
    "filter-tab-data",
    () => gate.searchInput(),
    {
      select: (data: any) => data?.data?.output,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const {
    query,
    entityType,
    courseType,
    fromPrice,
    toPrice,
    courseCategoryIds,
    teacherIds,
    certificateIds,
    sortBy,
    pageNumber,
  } = state;

  const searchData = useRef({
    query,
    entityType,
    courseType,
    fromPrice,
    toPrice,
    courseCategoryIds,
    teacherIds,
    certificateIds,
    sortBy,
  });

  const submit = (data: any) => {
    dispatch(setPageNumber({ pageNumber: 1 }));
    searchData.current = {
      query: data.query,
      entityType: data.entityType,
      courseType: data.courseType,
      fromPrice: data.fromPrice,
      toPrice: data.toPrice,
      courseCategoryIds: data.courseCategoryIds,
      teacherIds: data.teacherIds,
      certificateIds: data.certificateIds,
      sortBy: data.sortBy,
    };

    setSearchDto({
      ...searchDto,
      pageNumber: 1,
    });
  };
  useEffect(() => {
    searchData.current = {
      query: state.query,
      entityType: state.entityType,
      courseType: state.courseType,
      fromPrice: state.fromPrice,
      toPrice: state.toPrice,
      courseCategoryIds: state.courseCategoryIds,
      teacherIds: state.teacherIds,
      certificateIds: state.certificateIds,
      sortBy: state.sortBy,
    };
  }, [state]);
  useEffect(() => {
    mutate(
      {
        query: pageQuery?.query ? pageQuery?.query : searchData.current.query,
        entityType: pageQuery?.entityType
          ? [+pageQuery?.entityType]
          : searchData.current.entityType,
        courseType: pageQuery?.type
          ? [+pageQuery?.type]
          : searchData.current.courseType,
        fromPrice: searchData.current.fromPrice,
        ...(pageQuery?.types !== "free" && {
          toPrice: searchData.current.toPrice,
        }),
        courseCategoryIds: searchData.current.courseCategoryIds,
        teacherIds: searchData.current.teacherIds,
        certificateIds: searchData.current.certificateIds,
        sortBy: searchData.current.sortBy,
        searchDto: searchDto,
      },
      {
        onSuccess: (data: any) => {
          if (!isFirstMounted.current) {
            const getOffsetTop =
              document.getElementById("postsWrapper")?.offsetTop;
            window.scrollTo({
              top:
                getOffsetTop && getOffsetTop > 0
                  ? getOffsetTop - 30
                  : getOffsetTop,
              behavior: "smooth",
            });
          }
          setRecommendedList(data?.data?.output?.recommended);
          setTotalCount(data?.pagination.totalCount);
          if (isFirstMounted.current) {
            isFirstMounted.current = false;
          }
        },
      }
    );
  }, [pageQuery, sortBy, searchDto]);

  const onShowChange = (data: { key: string; value: string }) => {
    setSearchDto({
      ...searchDto,
      pageSize: +data.key,
      pageNumber: 1,
    });
  };

  const pageNumbersHandler = (pageNumber: number, pageSize: number) => {
    if (totalCount) {
      const totalPages =
        totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
      // last page
      if (pageNumber === totalPages) {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {totalCount}
          </>
        );
        // first page
      } else if (pageNumber === 1) {
        return (
          <>
            {pageNumber} - {pageSize}
          </>
        );
        // middle pages
      } else {
        return (
          <>
            {pageNumber * pageSize - pageSize + 1} - {pageNumber * pageSize}
          </>
        );
      }
    }
    return null;
  };

  const scrollToPostsWrapper = () => {
    if (_timer) {
      clearTimeout(_timer);
    }
    _timer = setTimeout(() => {
      const getOffsetTop = document.getElementById("postsWrapper")?.offsetTop;
      window.scrollTo({
        top:
          getOffsetTop && getOffsetTop > 0 ? getOffsetTop - 30 : getOffsetTop,
        behavior: "smooth",
      });
    }, 0);
  };

  const onPageChange = (page: number) => {
    scrollToPostsWrapper();
    dispatch(setPageNumber({ pageNumber: page }));
    setSearchDto({
      ...searchDto,
      pageNumber: page,
    });
  };

  const delayedQuery = useRef(
    debounce((data) => {
      submit(data);
    }, 500)
  ).current;

  return (
    <div className="py-4 md:py-8 xl:pt-10 xl:pb-20" id="postsWrapper">
      <div className="mx-auto w-[81%] md:w-[84%] xl:w-[73.9%]">
        <>
          <DesktopTab submit={submit} data={data} />
          <div className="hidden h-px  w-full bg-[#B8B7B7] md:my-5 md:flex 2xl:my-10" />{" "}
          <div className="mb-10 hidden w-full justify-between md:flex">
            <Title
              title={`${totalCount ? totalCount : 0} مورد جستجو`}
              wrapperClass="md:!text-xs font-normal lg:!text-lg"
            />
            <div className="hidden items-center md:flex">
              <span className="flex items-center">
                <Sort className="ml-[10px]" />
                مرتب‌سازی بر اساس
              </span>
              <DropDown
                title={getTitleByEnum(sortBy) ?? "همه"}
                Icon={FillArrow}
                btnClass="!justify-end focus-within:!bg-transparent focus-within:!shadow-none pl-0 gap-x-5 border-none"
                menu_class="md:!-right-10 xl:right-0"
              >
                <ul className="z-50 flex w-52 flex-col gap-y-2 rounded-lg bg-white p-2">
                  {sortList.map(({ title, value }) => (
                    <li
                      onClick={() => dispatch(setSortBy(+value))}
                      key={generateUuidForReactList()}
                      className={`cursor-pointer hover:text-blue-550 ${
                        sortBy == value && "text-blue-550"
                      }`}
                    >
                      {title}
                    </li>
                  ))}
                </ul>
              </DropDown>
            </div>
          </div>
          <div className="block md:hidden">
            <label className="relative block">
              <span className="absolute inset-y-0 right-0 flex items-center pr-[10px]">
                <Search />
              </span>
              <input
                type="text"
                name="search"
                value={query}
                onChange={(e: any) => {
                  dispatch(setFilterQuery({ query: e.target.value }));
                  delayedQuery({
                    query: e.target.value,
                    entityType: entityType,
                    courseType: courseType,
                    fromPrice,
                    toPrice,
                    courseCategoryIds,
                    teacherIds,
                    certificateIds,
                    sortBy,
                  });
                }}
                className="block w-full rounded-full border border-blue-550 bg-white py-2 pr-9 pl-3 text-xs text-blue-550 shadow-sm placeholder:text-blue-550 focus:border-blue-550 focus:outline-none focus:ring-1 focus:ring-blue-550 sm:text-sm"
                placeholder="جستجو"
              />
            </label>
          </div>
          <div className="flex gap-x-2 border-b border-[#B8B7B7] py-4 text-xs md:hidden">
            <Link href={isSuccess ? "/search/filter" : "/search"}>
              <Button CClassName="px-3 py-2 whitespace-nowrap !justify-between bg-blue-550/10 text-blue-550 w-full !rounded-full">
                <Filter />
                فیلتر
                <span />
              </Button>
            </Link>
            <div className="w-full">
              <DropDown
                title={getTitleByEnum(sortBy) ?? "همه"}
                Icon={Sort}
                btnClass="!justify-end gap-x-7 px-3 whitespace-nowrap flex-row-reverse !bg-blue-550/10 border-none"
                menu_class="!-left-16 md:!left-0"
                isLeft={true}
              >
                <ul className="flex w-52 flex-col gap-y-2 bg-white p-2 text-[10px]">
                  {sortList.map(({ title, value }) => (
                    <li
                      onClick={() => dispatch(setSortBy(+value))}
                      key={generateUuidForReactList()}
                      className={`cursor-pointer hover:text-blue-550 ${
                        sortBy == value && "text-blue-550"
                      }`}
                    >
                      {title}
                    </li>
                  ))}
                </ul>
              </DropDown>
            </div>
          </div>
          <div className="my-6 flex md:!hidden">
            <Title
              title={`${totalCount ? totalCount : 0} مورد جستجو`}
              wrapperClass="!font-normal -z-10 !text-xs"
            />
          </div>
          {isLoading && (
            <Spinner className="mx-auto h-10 w-10 animate-opacity animate-fade-in-down" />
          )}
          {items?.data?.output?.table?.rows.length == 0 ? (
            <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
              <Surprise />
              <p>
                لطفا یکی از گزینه های فیلتر را انتخاب کنید یا دوره مورد نظر را
                جستجو کنید.
              </p>
            </div>
          ) : (
            <ul>
              {items?.data?.output?.table?.rows?.map((item: any) => (
                <Items key={generateUuidForReactList()} item={item} />
              ))}
            </ul>
          )}
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2">
            <div>
              {totalCount && totalCount > searchDto.pageSize ? (
                <Pagination
                  totalCount={totalCount}
                  pageSize={searchDto.pageSize}
                  onPageChange={onPageChange}
                  selectedPage={pageNumber}
                />
              ) : undefined}
            </div>
            <div>
              {(totalCount && totalCount > searchDto.pageSize) ||
              searchDto.pageSize !== 15 ? (
                <div className="mt-4 flex items-center justify-center md:mt-0 md:justify-end">
                  <span className="ml-5">
                    نمایش{" "}
                    {pageNumbersHandler(
                      searchDto.pageNumber,
                      searchDto.pageSize
                    )}{" "}
                    از {totalCount}
                  </span>
                  <CustomSelectOption
                    list={[
                      { key: "15", value: "نمایش 15" },
                      { key: "20", value: "نمایش 20" },
                      { key: "30", value: "نمایش 30" },
                      { key: "50", value: "نمایش 50" },
                    ]}
                    isRtl={false}
                    onChange={onShowChange}
                  />
                </div>
              ) : undefined}
            </div>
          </div>
          {recommendedList ? (
            <div className="mt-[71px]">
              {recommendedList.length == 0 ? (
                <div className="flex h-[60vh] items-start gap-x-5 text-xs md:text-base">
                  <Surprise />
                  <p>موردی یافت نشد.</p>
                </div>
              ) : (
                <NewCourses
                  title="دوره ها و بسته های پیشنهادی"
                  data={recommendedList}
                  breakpoints={{
                    300: {
                      slidesPerView: 1,
                      spaceBetween: 5,
                    },
                    375: {
                      slidesPerView: 1.1,
                      spaceBetween: 5,
                    },
                    767: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                    },
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 24,
                    },
                  }}
                />
              )}
            </div>
          ) : undefined}
        </>
      </div>
    </div>
  );
};
export async function getServerSideProps(ctx: NextPageContext): Promise<{
  props: {
    urlQuery: any;
  };
}> {
  return {
    props: { urlQuery: ctx?.query },
  };
}
export default Index;
